var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.477,
    height: 25.392,
    viewBox: "0 0 25.477 25.392",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logout",
    transform: "translate(0 -0.85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29164",
    "data-name": "Group 29164",
    transform: "translate(0 0.85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29163",
    "data-name": "Group 29163"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65341",
    "data-name": "Path 65341",
    d: "M12.7,24.126H3.174a1.058,1.058,0,0,1-1.058-1.058V4.024A1.058,1.058,0,0,1,3.174,2.966H12.7A1.058,1.058,0,0,0,12.7.85H3.174A3.178,3.178,0,0,0,0,4.024V23.068a3.178,3.178,0,0,0,3.174,3.174H12.7a1.058,1.058,0,1,0,0-2.116Z",
    transform: "translate(0 -0.85)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29166",
    "data-name": "Group 29166",
    transform: "translate(8.464 6.14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29165",
    "data-name": "Group 29165"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65342",
    "data-name": "Path 65342",
    d: "M186.8,113.817l-6.433-6.348a1.058,1.058,0,1,0-1.485,1.507l4.6,4.537H171.158a1.058,1.058,0,0,0,0,2.116h12.318l-4.6,4.537a1.058,1.058,0,1,0,1.485,1.507l6.433-6.348a1.057,1.057,0,0,0,0-1.507Z",
    transform: "translate(-170.1 -107.165)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.5b4d1be0b59b7a4d3da72b27ad2a1d52.svg";
export { ForwardRef as ReactComponent };